import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { TUser } from 'shared/types/user';

export const initialState = {
  isAuthenticated: false,
} as TUser;

const userSlice = createSlice({
  initialState,
  name: 'user',
  reducers: {
    setUserData: (_, action: PayloadAction<TUser>) => action.payload,
  },
});

export const {
  reducer: userReducer,
  actions: { setUserData },
} = userSlice;
